import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const StyledToastContainer = () => (
  <ToastContainer
    position="bottom-right"
    autoClose={5000}
    hideProgressBar={false}
    newestOnTop
    closeOnClick
    rtl={false}
    theme="light"
  />
);
